import withRouter from "../utils/withRouter";

function ScrollToTop() {
  typeof window !== "undefined" && window.scrollTo(0, 0);
}
export default withRouter(ScrollToTop);
